import consola from "consola"
import { cloneDeep } from "lodash"

import { isCloudEnv, isProdEnv } from "utils/env"

const injectLogger =
  (methodOrigin: Function) =>
  (...args: any[]) => {
    const [
      method,
      p2,
      params,
      p3,
      p4,
      actionOrCallback,
      errorCallback,
      ...rest
    ] = args || []
    const isNoReduxAction = typeof actionOrCallback !== "string"
    const actionName = isNoReduxAction ? "no redux" : actionOrCallback
    const titleCSS = "color: #BBBBBB; font-weight: lighter;"
    const decentTitleCSS = "color: #898989; font-weight: lighter;"
    const logStart = () => {
      console.groupCollapsed(
        `%c ${"request"} %c ${actionName.toUpperCase()} %c (${method})`,
        titleCSS,
        ...(isNoReduxAction
          ? [decentTitleCSS, decentTitleCSS]
          : ["", decentTitleCSS])
      )
      console.log("%c method    ", `color: #03A9F4; font-weight: bold`, method)
      console.log(
        "%c params    ",
        `color: #9E9E9E; font-weight: bold`,
        cloneDeep(params)
      )
    }
    const logSuccess = (response?: any) => {
      consola.success(
        isNoReduxAction ? response : `see result in action ${actionName}`
      )
    }
    const logError = (err?: any, msg?: string) => {
      consola.error(err, msg)
    }
    const logEnd = () => {
      console.groupEnd()
    }

    if (isNoReduxAction) {
      const injectedSuccessCallback = (response: any) => {
        logStart()
        logSuccess(response)
        logEnd()
        if (typeof actionOrCallback === "function") {
          actionOrCallback(response)
        }
      }
      const injectedErrorCallback = (err?: any, msg?: string) => {
        logStart()
        logError(err, msg)
        logEnd()
        if (typeof errorCallback === "function") {
          errorCallback(err, msg)
        }
      }
      methodOrigin.apply(null, [
        method,
        p2,
        params,
        p3,
        p4,
        injectedSuccessCallback,
        injectedErrorCallback,
        ...rest,
      ])
    } else {
      logStart()
      logSuccess()
      logEnd()
      methodOrigin.apply(null, args)
    }
  }

if (isCloudEnv()) {
  // hijack prinmingcloud api add logger for backend calls
  window.parent.primingcloud.integration.callIncomingWithParameters_default =
    window.parent.primingcloud.integration.callIncomingWithParameters
  window.parent.primingcloud.integration.callIncomingWithParameters =
    injectLogger(
      window.parent.primingcloud.integration.callIncomingWithParameters_default
    )
}

export const call = async <T>(
  method: string,
  params: {} & any,
  customer: string = process.env.REACT_APP_API_CUSTOMER,
  username: string = process.env.REACT_APP_API_USERNAME,
  password: string = process.env.REACT_APP_API_PASSWORD,
  timeout: number = 60000
): Promise<T> => {
  const host = process.env.REACT_APP_API_HOST
  const host_prod = process.env.REACT_APP_API_HOST_PROD
  const application = process.env.REACT_APP_API_APPLICATION
  if (!isProdEnv() || isCloudEnv()) {
    return fetch(
      `https://${host}/data/integration/${customer}/${application}/${method}?ouname=root&application=${application}&customer=${customer}&username=${username}&password=${password}`,
      {
        method: "POST",
        mode: "cors",
        cache: "default",
        body: JSON.stringify(params),
      }
    ).then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.json() as Promise<T>
    })
  } else {
    return fetch(
      `https://${host_prod}/data/integration/${customer}/${application}/${method}?ouname=root&application=${application}&customer=${customer}&username=${username}&password=${password}`,
      {
        method: "POST",
        mode: "cors",
        cache: "default",
        body: JSON.stringify(params),
      }
    ).then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.json() as Promise<T>
    })
  }
}

export enum APIMethods {
  USER_LISTALL = "LIST_USERS",
  VAS_LISTALL = "LIST_VAS",
  TECDOC_GETCOUNTRIES = "getCountries",
  TECDOC_GETARTICLE = "getArticleDirectSearchAllNumbersWithState",
  TECDOC_GETBRANDDETAILS = "getAmBrandAddress",
  TECDOC_GETARTICLEDETAILS = "getDirectArticlesByIds6",
  TECDOC_ADDIPADDRESS = "addDynamicAddress",
  TECDOC_GETVEHICLELIST = "getArticleLinkedAllLinkingTarget3",
  TECDOC_GETVEHICLEDETAILSLIST = "getVehicleByIds4",
  TECDOC_GETVEHICLELISTIMMEDIATEATTRIBUTS = "getArticleLinkedAllLinkingTargetsByIds3",
}
